/**
 * Barre de progression du panier : ajoute le cadeau choisi par le client.
 * Le rabais qui rend le produit gratuit est géré par Shopify.
 */
class CartProgressBar extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

  /** @param {Event} event */
  onClick(event) {
    const button = event.target.closest('[data-gift-variant-id]');
    if (!button || button.disabled) return;
    this.addGift(button);
  }

  /** @param {HTMLButtonElement} button */
  async addGift(button) {
    const variantId = button.dataset.giftVariantId;
    if (!variantId) return;

    const buttons = this.querySelectorAll('[data-gift-variant-id]');
    buttons.forEach((b) => (b.disabled = true));

    // Éléments du panier à rafraîchir (tiroir ou page panier)
    const cartItems = this.closest('cart-drawer-items') || this.closest('cart-items');
    const sectionsToRender = cartItems ? cartItems.getSectionsToRender() : [];

    const body = {
      id: Number(variantId),
      quantity: 1,
      sections: sectionsToRender.map((section) => section.section).join(','),
      sections_url: window.location.pathname,
    };
    if (this.dataset.giftProperty === 'true') {
      // La propriété contient le numéro du palier : un même produit peut être offert à plusieurs paliers
      body.properties = { _cadeau: button.dataset.giftTier || 'true' };
    }

    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const state = await response.json();

      if (state.status) {
        throw new Error(state.description || state.message || 'Add to cart failed');
      }

      sectionsToRender.forEach((section) => {
        const target = document.getElementById(section.id);
        if (!target || !state.sections || !state.sections[section.section]) return;
        const element = target.querySelector(section.selector) || target;
        element.innerHTML = cartItems.getSectionInnerHTML(state.sections[section.section], section.selector);
      });

      document.querySelector('cart-drawer')?.classList.remove('is-empty');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-progress-bar', cartData: state });
      }
    } catch (error) {
      console.error(error);
      buttons.forEach((b) => (b.disabled = false));
    }
  }
}

if (!customElements.get('cart-progress-bar')) {
  customElements.define('cart-progress-bar', CartProgressBar);
}
